import type { Crossing } from '../db/database';

/**
 * Tipo di punto da usare sulla planimetria in base al supporto degli attraversamenti.
 *
 * Un attraversamento a solaio si disegna come punto solaio, uno a parete come punto
 * parete. Se una mappatura ne contiene di entrambi i tipi nessuno dei due marcatori
 * la descrive, quindi resta generico.
 */
export function determinePointTypeFromCrossings(crossings: Crossing[]): 'parete' | 'solaio' | 'generico' {
  const supporti = crossings
    .map(c => c.supporto?.toLowerCase().trim())
    .filter((value): value is string => Boolean(value));

  if (supporti.length === 0) return 'parete';

  const first = supporti[0];
  if (!supporti.every(value => value === first)) return 'generico';
  return first === 'solaio' ? 'solaio' : 'parete';
}
